import { useQuery } from '@tanstack/react-query';
import { shouldUserSeeCaseInAmendment } from 'app/edozvola/cases/header/service/case-header.service';

export const shouldUserSeeCaseInAmendmentQuery = (idCase: string) => {
  return useQuery({
    queryKey: ['case-in-amendment', { idCase: idCase }],
    queryFn: () => shouldUserSeeCaseInAmendment(idCase),
  });
};
